var _circle, _circle2, _ellipse, _ellipse2, _path, _path2, _ellipse3, _ellipse4, _path3, _path4, _ellipse5, _ellipse6, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOverAccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F0F1F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 7,
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 7,
    cy: 24,
    rx: 2,
    ry: 2,
    transform: "rotate(90 7 24)",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 41,
    cy: 24,
    rx: 2,
    ry: 2,
    transform: "rotate(90 41 24)",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M12 24L14 24",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M34 24L36 24",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 11.9792,
    cy: 11.9785,
    rx: 2,
    ry: 2,
    transform: "rotate(135 11.9792 11.9785)",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 36.0208,
    cy: 36.0205,
    rx: 2,
    ry: 2,
    transform: "rotate(135 36.0208 36.0205)",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M15.5147 15.5146L16.9289 16.9289",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M31.0711 31.0703L32.4853 32.4845",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 24,
    cy: 7,
    rx: 2,
    ry: 2,
    transform: "rotate(-180 24 7)",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 24,
    cy: 41,
    rx: 2,
    ry: 2,
    transform: "rotate(-180 24 41)",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M24 12L24 14",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M24 34L24 36",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOverAccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/overAccess.57985da55fc931074f1f145d6f74e309.svg";